<template>
    <div id="app">
        <template
                v-if="$route.path=='/Login' || $route.path=='/' ||$route.path=='/Agreement'||$route.name=='Document Collection' || $route.name=='Privacy Policy'">
            <router-view></router-view>
        </template>
        <template v-else>
            <q-dialog v-model="notificationPopup">
                <NotificationPopup @closeDialog="notificationPopup=false"></NotificationPopup>
            </q-dialog>
            <q-layout :class="$route.name=='Dashboard'?'bg-grey': ''" view="lHh lpR lfr">
                <q-header :class="$route.name=='Dashboard'?'bg-grey': ''" class="bg-white text-black"
                          style="left: 70px; z-index: 1000;">
                    <q-toolbar>
                        <!--             <q-btn @click="left = !left" class="q-mr-md" dense flat icon="menu" round/>
                                     <img height="35" src="./assets/logo.png">    -->
                        <span class="text-h4"
                              style="font-weight: 200; padding-left: 5px;padding-top: 15px; padding-bottom: 15px; color: #3e4c4c;text-transform: capitalize !important ">{{$route.name}}<q-btn
                                @click="logout" dense flat icon="power_settings_new"
                                round style="position: absolute; right: 15px; top: 20px;"></q-btn>
                        </span>
                        <div>
                            <div class="position-absolute d-flex" style="align-items: center; right: 80px; top: 12px;">
                              <div class="my-active-count-box px-3 ml-3 cursor-pointer" @click="subBatchDialog=true"
                                   v-if="user&&![Constants.VAP, Constants.RP].includes(user.organization.partnerType)">
                                <p class="text-caption mb-0">My Active Batches</p>
                                <div class="sub-batch-count">{{ subBatches.length }}</div>
                              </div>
                                <div class="mr-4">
                                    <q-btn @click="gotoNotifications" flat icon="notifications_none" round>
                                        <q-badge color="red" floating transparent v-if="$unreadNotifications.length">
                                            {{$unreadNotifications.length}}
                                        </q-badge>
                                    </q-btn>
                                </div>
                                <div @click="gotoProfile" class="d-flex nd-info pr-3 pl-1" style="align-items: center;">
                                    <div :class="'nd-user-icon text-white ' + (user.partnerType.prefix==='RP'?'bg-'+user.partnerType.color:user.partnerType.color)">
                                        <span style="font-size: 12px">{{user.partnerType.prefix}}</span>
                                    </div>
                                    <div>
                                        <span class="ml-3 d-block"
                                              style="font-size: 14px">{{user.organization.name}}</span>
                                        <span class="ml-3 d-block" style="font-size: 14px">{{user.name}}</span>
                                        <!--<span class="ml-3 d-block" style="font-size: 14px">{{user.mobile}}</span>-->
                                    </div>
                                </div>


                            </div>
                        </div>
                        <!--          <q-space/>
                                  {{user?user.name:''}}
                                  <q-btn @click="logout" class="q-ml-md" dense flat icon="power_settings_new" round/>  -->
                    </q-toolbar>
                </q-header>

                <!--                <q-drawer :breakpoint="700" :mini="miniState" :width="220"-->
                <!--                          @mouseover="miniState = false"-->
                <!--                          @mouseout="miniState = true"-->
                <!--                          bordered side="left" v-model="left">-->
                <q-drawer :breakpoint="500"
                          :mini="miniState"
                          :mini-width="57"
                          :width="300"
                          @mouseout="miniState = true"
                          @mouseover="miniState = false"
                          bordered :content-class="miniState?'close-drawer-scroller-class':'open-drawer-scroller-class'"
                          mini-to-overlay
                          show-if-above
                          v-model="left">
                    <div @click="goToDashboard" class="absolute-top "
                         style="height: 50px; cursor: pointer;background: #0f5992;z-index: 1">
                        <div class="d-flex">
                            <q-item-section avatar style="background: #0f5992">
                                <img src="./assets/logo.png" style="width: 57px; margin-left: 0px;background: #0f5992">
                            </q-item-section>
                            <q-item-section class="ml-0 text-white">
                                Partner Portal
                            </q-item-section>
                        </div>

                        <q-separator></q-separator>
                    </div>

                    <!--((menu.name==='Partners'||menu.name==='Sales Detail') && user.organization.partnerType!=='921a8e09-766f-4894-b04c-495059858bb4')-->
                    <div style="margin-top: 80px; overflow-y: auto">
                        <q-list :class="menu.icon=='person'? 'bottom-menu':''" :key="index" class="menu-list" padding
                                v-for="(menu, index) in filteredMenuItems"
                                v-if="(menu.name==='My League' && user.organization.partnerType===Constants.VAP )||
                                ((menu.name==='Partners'||menu.name==='Sales Detail') && (user.organization.partnerType===Constants.RD||user.organization.partnerType===Constants.VAD||user.organization.partnerType===Constants.VP))||
                                (menu.name!=='Partners'&&menu.name!=='My League'&&menu.name!=='Sales Detail')">
                            <!--                            921a8e09-766f-4894-b04c-495059858bb4-->
                            <q-item :active="$route.name === menu.name" :to="menu.path" active-class="text-white"
                                    clickable v-ripple>
                                <q-item-section avatar>
                                    <q-icon :class="($route.name == menu.name) || (menu.name == 'Online Order' && $route.name == 'Place Online Order')?'menu-active':'menu-icons'"
                                            :name="menu.icon"/>
                                </q-item-section>
                                <q-item-section :class="($route.name == menu.name) || (menu.name == 'Online Order' && $route.name == 'Place Online Order')?'menu-active':'menu-icons'"
                                                :name="menu.icon">
                                    {{menu.name}}
                                </q-item-section>
                            </q-item>
                            <!--    <q-item :active="$route.name === menu.name" :to="menu.path" active-class="text-white"
                                        clickable v-else-if="menu.name!=='Partners'" v-ripple>
                                    <q-item-section avatar>
                                        <q-icon :class="$route.name == menu.name?'menu-active':'menu-icons'" :name="menu.icon"/>
                                    </q-item-section>
                                    <q-tooltip anchor="center right" self="center left" :offset="[10, 10]">
                                        <q-item-section>
                                            {{menu.name}}
                                        </q-item-section>
                                    </q-tooltip>
                                </q-item>    -->
                        </q-list>
                    </div>
                </q-drawer>

                <q-page-container>
                    <router-view style="padding-bottom: 70px;"/>

                    <footer class="footer-bar ">
                        <div class="row" style="align-items: center; padding-left: 25px; ">
                            <div class="col-3">
                                <p class="mb-0 mt-1" style="color: grey; font-size: 12px;">Powered by</p>
                                <div class="footer-logo mb-2">
                                    <a href="http://www.amitygroup.in/" target="_blank">
                                        <img alt="" class="w-100 d-block mx-auto" src="../src/assets/footer-logo.png">
                                    </a>
                                </div>
                            </div>
                            <div class="col-6">
                                <p class="text-center mb-1" style="color: grey">For More Detail Contact Us on : 0261
                                    6657000 I <a href="" style="color: grey">support@amitybiz.net</a></p>
                                <p class="text-center mb-1" style="color: #959595; font-size: 12px;">Copyright &copy;
                                    2019 Amity Infosoft (P) Ltd., All rights reserved</p>
                            </div>
                            <div class="col-3">
                                <div class="d-flex" style="justify-content: flex-end;">
                                    <div class="social-icons mx-2">
                                        <a href="https://www.facebook.com/amityinfosoft" target="_blank"><i
                                                class="fab fa-facebook-f"></i></a>
                                    </div>
                                    <div class="social-icons mx-2">
                                        <a href="https://www.linkedin.com/company/amityinfosoft" target="_blank"><i
                                                class="fab fa-linkedin-in"></i></a>
                                    </div>
                                    <div class="social-icons mx-2">
                                        <a href="https://twitter.com/Amityinfosoft" target="_blank"><i
                                                class="fab fa-twitter"></i></a>
                                    </div>
                                    <div class="social-icons ml-2">
                                        <a href="https://www.instagram.com/amityinfosoft/" target="_blank"><i
                                                class="fab fa-instagram"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </footer>

                </q-page-container>
            </q-layout>
        </template>

      <ManageActiveSubBatches :subBatchDialog.sync="subBatchDialog" v-if="subBatchDialog"/>
    </div>
</template>
<script>
    import Constants from './Constants/Constant'
    import {DELETE_SESSION_BY_TOKEN, UPDATE_FCM_TOKEN} from './graphql/mutations/user'
    import {
        deleteObjectStore,
        refreshNotification,
        storeNotification,
    } from './components/Notifications/NotificationUtils'
    import NotificationPopup from './components/Notifications/NotificationPopup'
    import ManageActiveSubBatches from "@/components/ManageSubBatches/ManageActiveSubBatches";
    import {SUBSCRIBE_ACTIVE_NOT_SOLD_SUB_BATCH} from "@/graphql/subscription/batch";

    export default {
        name: 'app',
        components: {ManageActiveSubBatches, NotificationPopup},
        apollo:{
          $subscribe:{
            subBatches: {
              query: SUBSCRIBE_ACTIVE_NOT_SOLD_SUB_BATCH,
              skip(){ return ['/Login','/Agreement'].includes(this.$route.path) ||
                  ['Document Collection','Privacy Policy'].includes(this.$route.name) || !localStorage.user },
              variables () { return { orgId: this.user.orgId }},
              result({data}) { this.subBatches = data.subBatches }
            }
          }
        },
        data() {
            return {
                Constants: Constants,
                left: false,
                miniState: true,
                menuItems: [
                    {path: '/Partners/Dashboard', name: 'Dashboard', icon: 'dashboard', index: 1},
                    // { path: '/Applications', name: 'Applications', icon: 'notes' , index: 0},
                    {path: '/Partners/Partners', name: 'Partners', icon: 'supervised_user_circle', index: 2},
                    {path: '/Partners/MyLeague', name: 'My League', icon: 'contacts', index: 3},
                    // { path: '/Partners/ManageStock', name: 'Stock Management', icon: 'inbox' , index: 0},
                    {path: '/Partners/Stock', name: 'Stock Management', icon: 'shopping_basket', index: 4},
                    {path: '/Partners/RetailSales', name: 'Retail Sales Detail', icon: 'chrome_reader_mode', index: 6},
                    {path: '/Partners/Sales', name: 'Sales Detail', icon: 'cloud_upload', index: 7},
                    {path: '/Partners/Purchase', name: 'Purchase Detail', icon: 'cloud_download', index: 8},
                    // {path: '/Partners/PartnerEngagementProgramme', name: 'ESET - Amity Program', icon: 'grade', index: 0},
                    {path: '/Partners/Scheme', name: 'Scheme', icon: 'local_offer', index: 10},
                    {path: '/Partners/Links', name: 'Useful Links', icon: 'menu_book', index: 11},
                    {path: '/ReturnOrders', name: 'Return Orders', icon: 'keyboard_return', index: 12},
                    {path: '/Supports', name: 'Supports', icon: 'contact_support', index: 13},
                    // { path: '/Partners/Profile', name: 'My Profile', icon: 'person' , index: 0},
                    // { path: '/CreatePartner', name: 'Partner Registration', icon: 'business_center' , index: 0},
                ],
                menuItems2: [
                    {path: '/Partners/Stock/Products', name: 'Online Order', icon: 'shopping_basket', index: 2},
                    // {path: '/Partners/Stock/StockOnline', name: 'Stock Management(Online)', icon: 'shopping_basket', index: 5},
                    // {path: '/Partners/Purchase/PurchaseOnline', name: 'Purchase Detail(Online)', icon: 'cloud_download', index: 9},
                ],
                user: JSON.parse(localStorage.getItem('user')),
                notificationPopup: false,
                defaultNotificationImage: require('../src/assets/eye.png'),
                subBatches: [],
                subBatchDialog: false
            }
        },
        computed: {
                filteredMenuItems() {
                if (this.user?.organization?.onlineOfflineType === 2) {
                    return this.menuItems
                } else {
                    const mergedMenu = this.menuItems.concat(this.menuItems2);
                    const sortedMenu = mergedMenu.sort((a, b) => (a.index || Infinity) - (b.index || Infinity));
                    return sortedMenu;
                }
            },
        },
        methods: {
            // notificationClick (payload) {
            //   if (payload && payload.data && payload.data.notificationType) {
            //     onNotificationClick(payload)
            //     if (payload.data.notificationType == '33' || payload.data.notificationType == '44')
            //       this.notificationPopup = true
            //   }
            // },
            async logout() {
                let self = this
                this.$q.dialog({
                    title: 'Logout',
                    message: 'Are you Sure, you want to Logout?',
                    cancel: true,
                    persistent: true,
                }).onOk(() => {
                    self.$apollo.mutate({
                        mutation: DELETE_SESSION_BY_TOKEN,
                        variables: {token: localStorage.token},
                    })
                    deleteObjectStore()
                    setTimeout(function () {
                        localStorage.clear()
                        self.$router.replace({path: '/'})
                    }, 500)
                    // apolloClient.cache.reset()
                })
            },
            goToDashboard() {
                this.$router.replace({path: '/Partners/Dashboard'})
            },
            gotoProfile() {
                this.$router.replace({path: '/Partners/Profile'})
            },
            gotoNotifications() {
                this.$router.push('/Partners/Notifications').catch(()=>{})
                this.$forceUpdate()
            },
            async bindFCMToken() {
                if (localStorage.token && localStorage.fToken) {
                    let response = await this.$apollo.mutate({
                        mutation: UPDATE_FCM_TOKEN,
                        variables: {
                            token: localStorage.token,
                            fcmToken: localStorage.fToken,
                        },
                    })
                }
            },
        },
        watch: {
            '$route'() {
                refreshNotification()
                this.user = JSON.parse(localStorage.getItem('user'))
                if (!this.user && (this.$route.name == 'Login' || this.$route.name == 'Dashboard'))
                    this.$router.push('/').catch(()=>{})
                else if (this.user && this.$route.name == 'Login')
                    this.$router.push('/Partners/Dashboard').catch(()=>{})
                else
                    this.$router.push(this.$route.fullPath).catch(()=>{})
            },
        },
        mounted() {
            let self = this
            refreshNotification()
            firebase.initializeApp(Constants.firebaseConfig)
            const messaging = firebase.messaging()
            navigator.serviceWorker.register('./firebase-messaging-sw.js').then((registration) => {
                messaging.useServiceWorker(registration)
                messaging.requestPermission().then(() => {
                    messaging.getToken().then(fcmToken => {
                        if (fcmToken) {
                            localStorage.setItem('fToken', fcmToken)
                            this.bindFCMToken()
                        }
                    })
                    messaging.onTokenRefresh(() => {
                        messaging.getToken().then(fcmToken => {
                            if (fcmToken) {
                                localStorage.setItem('fToken', fcmToken)
                                this.bindFCMToken()
                            }
                        })
                    })
                })
            }).catch(err => {
                console.log(err)
            })
            firebase.messaging().onMessage((payload) => {
                payload['status'] = 'UNREAD'
                storeNotification(payload)
                self.$forceUpdate()
            })
            setInterval(function () {
                refreshNotification()
                self.$forceUpdate()
            }, self.Constants.notificationTimeout)
        },
    }
</script>
<style lang="scss">
    * {
        /*font-family: Consolas, Monaco, Andale Mono, Ubuntu Mono, monospace;*/
        font-family: 'Work Sans', sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        /*text-align: center;*/
        /*color: #2c3e50;*/
    }

    #nav {
        padding: 30px;

        a {
            font-weight: bold;
            color: #2c3e50;

            &.router-link-exact-active {
                color: #42b983;
            }
        }
    }
</style>
<style scoped>


    .bg-grey {
        background-color: #eff5f4 !important;
    }

    /deep/ .fit > div > div.full-width {
        position: relative !important;
        height: 100%;
    }

    .bottom-menu {
        position: absolute;
        bottom: 72px;
        width: 100%;
    }

    /deep/ .q-drawer--left > div.scroll {
        overflow: hidden;
        background: #105992 !important;
        /*width: 70px !important;*/
    }

    .menu-icons {
        color: #b5b5b5;

    }

    .menu-active {
        color: #fff;
    }

    /deep/ .q-drawer--left > div.scroll {
        overflow: hidden;
    }

    /deep/ .q-drawer--left > div.scroll {
        overflow: hidden;
    }

    /deep/ .q-drawer--mini {
        position: fixed;
    }

</style>
<style>
    @font-face {
        font-family: avenirRegular;
        src: url("../public/fonts/AvenirNext-Regular-08.ttf");
    }

    @font-face {
        font-family: avenirBold;
        src: url("../public/fonts/AvenirNext-Bold-01.ttf");
    }
    @font-face {
        font-family: "Avenir Bold";
        src: url("../public/fonts/AvenirNext-DemiBold-03.ttf");
    }

    * {
        font-family: avenirRegular;

    }

    .notification-list:hover {
        background-color: rgba(62, 65, 60, 0.5);
    }

    .open-drawer-scroller-class {
        overflow: auto !important;
    }

    .close-drawer-scroller-class {
        overflow: hidden !important;
    }
    .my-active-count-box {
      background: #E7EFF4;
      border-radius: 10px;
      color: #115A92;
    }
    .sub-batch-count{
      font-weight: 800; font-size: 16px;  text-align: center
    }
</style>
<style scoped>
    /deep/ .q-drawer {
        position: fixed !important;
        z-index: 9999969;
    }

</style>
